module.exports = __webpack_public_path__ + "static/media/Poppins-Thin.25cd0f68.ttf";